import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardWidget = ({ title, icon, iconColor, value, subtitle, action, onActionClick, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card border-border',
    primary: 'bg-primary/5 border-primary/20',
    success: 'bg-success/5 border-success/20',
    warning: 'bg-warning/5 border-warning/20'
  };

  return (
    <div className={`border rounded-lg p-6 transition-smooth hover:shadow-md ${variantStyles?.[variant]}`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${iconColor || 'bg-primary/10'}`}>
            <Icon name={icon} size={24} color={iconColor?.includes('primary') ? 'var(--color-primary)' : 'currentColor'} />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
            <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
          </div>
        </div>
      </div>
      {subtitle && (
        <p className="text-sm text-muted-foreground mb-3">{subtitle}</p>
      )}
      {action && onActionClick && (
        <Button
          variant="outline"
          size="sm"
          onClick={onActionClick}
          className="w-full"
        >
          {action}
        </Button>
      )}
    </div>
  );
};

export default DashboardWidget;
